import {Component, OnInit} from '@angular/core';
import * as moment from 'moment';
import {combineLatest} from 'rxjs/observable/combineLatest';
import {UpdateAuthUser} from '@store/auth/actions';
import {ConfirmModalComponent} from '@components/confirm-modal/confirm-modal.component';
import {MatDialog} from '@node_modules/@angular/material';
import {AttendanceService} from '@services/attendance/attendance.service';
import {Store} from '@node_modules/@ngrx/store';
import * as AuthReducer from '@store/auth/reducers';
import {Router} from '@node_modules/@angular/router';
import {PaymentService} from '@services/payment/payment.service';
import {User} from '@models/user';
import {Attendance} from '@models/attendance';
import {AccountService} from '@services/account/account.service';
import {Lesson} from '@models/lesson';
import {ProgramViewComponent} from '@components/program-view/program-view.component';
import {StartSpinner, StopSpinner} from '@store/spinner/actions';
import * as SpinnerReducer from '@store/spinner/reducers';
import {OnboardingRegisterComponent} from '@components/onboarding-register/onboarding-register.component';
import {RechargeFailedChargeStudentDialog} from '@components/recharge-failed-charge-student-dialog/recharge-failed-charge-student-dialog.component';

@Component({
  selector: 'app-check-in-options',
  templateUrl: './check-in-options.component.html',
  styleUrls: ['./check-in-options.component.scss']
})
export class CheckInOptionsComponent implements OnInit {
  static classes;
  static modalRef;
  static selectedProgram;
  // static selectedSchedule;
  static user;
  classes;
  searchStudents: User[] = [];
  confirmDialog;
  overduePayments;
  user;
  nextPayments;
  previousPayments;
  selectedClassSchedule;
  searchStudentsString = '';
  selectedClassScheduleId;
  users = [];
  classesSchedulesForCheckIn = [];
  studentsIds = [];
  schedules = [];
  attendancesByDay: Attendance[] = [];
  students;
  selectedProgram;
  onboardingRegisterDialog;
  rechargeFailedChargeStudentDialog;

  constructor(
    public dialog: MatDialog,
    private attendanceService: AttendanceService,
    private authStore: Store<AuthReducer.AuthState>,
    private router: Router,
    private paymentsService: PaymentService,
    private accountService: AccountService,
    private spinnerStore: Store<SpinnerReducer.SpinnerState>
  ) {
  }

  async ngOnInit() {
    this.user = CheckInOptionsComponent.user;
    this.classes = CheckInOptionsComponent.classes;
    const weekDay = this.getDay();
    this.selectedProgram = CheckInOptionsComponent.selectedProgram;
    for (let i = 0; i < this.user.subscriptions.length; i++) {
      if (this.user.subscriptions[i].program_id === this.selectedProgram) {
        this.studentsIds.push(this.user.id);
        break;
      }
    }
    this.user.family.map(member => {
      this.studentsIds.push(member.id);
    });
    this.classes.map(curClass => {
      const schedules = ProgramViewComponent.refactorSchedule(curClass.schedule);
      schedules.map(schedule => {
        if (weekDay === schedule.fullDayName) {
          schedule.class_name = curClass.name;
          this.schedules.push(schedule);
        }
      });
    });
    this.selectedClassSchedule = this.schedules[0];
    this.selectedClassScheduleId = this.schedules[0].id;
    const arr = await this.getAttendance();

    this.spinnerStore.dispatch(new StopSpinner());

    // console.log(this.getDay());
  }

  getDay() {
    const weekday = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    const mydate = new Date();
    return weekday[mydate.getDay()];
  }

  async selectClassSchedule(event) {
    this.schedules.map(schedule => {
      if (schedule.id === event.value) {
        this.selectedClassSchedule = Object.assign({}, schedule);
      }
    });
    await this.getAttendance();
  }

  getAttendance() {
    this.students = [];
    this.searchStudents = [];
    const subscriptionsUsersAccount = [];
    return new Promise(resolve => {
      this.studentsIds.map(id => {
        subscriptionsUsersAccount.push(this.accountService.getUserById(id));
      });
      combineLatest(subscriptionsUsersAccount).subscribe(repsns => {
        const subscriptionsUsersAttendances = [];
        repsns.map((resp: { data: User }) => {
          if (resp.data.programs_id.includes(this.selectedProgram)) {
            this.students.push(resp.data);
            this.searchStudents.push(resp.data);
            subscriptionsUsersAttendances.push(this.attendanceService.getStudentAttendences({user_id: resp.data.id, period: 'day'}));
          }
        });
        combineLatest(subscriptionsUsersAttendances).subscribe(resps => {
          resps.map((resp1: { data: Attendance[] }) => {
            if (resp1.data.length) {
              this.attendancesByDay = resp1.data;
              resp1.data.map(attendance => {
                if (attendance.schedule_id === this.selectedClassScheduleId) {
                  this.students.map(student => {
                    if (attendance.user_id === student.id) {
                      student.checkedIn = 1;
                    }
                  });
                }
              });
            }
          });
          resolve(true);
        });
      });
    });
  }

  checkin(family) {
    if (family) {
      this.send(null);
    } else {
      this.classesSchedulesForCheckIn.map(schedule => {
        this.send(schedule);
        // for (let i = 0; i < this.classes.length; i++) {
        //     console.log('22222222222', schedule.id);
        //     if (this.classes[i].id === schedule.class_id) {
        //         console.log('333333333');
        //         this.send(this.classes[i], schedule);
        //         break;
        //     }
        // }
      });
    }
  }
  toggleMembers() {
    if (this.users && this.users.length > 0) {
      this.users = [];
    } else {
      this.users = this.students.map( s => s.id);
    }
  }
  send(schedule) {
    const isFamilyMember = this.user.family.length > 0;
    const selectedScheduleLessonId = this.selectedClassSchedule && this.selectedClassSchedule.lesson && this.selectedClassSchedule.lesson.id
      ? this.selectedClassSchedule.lesson.id
      : null;
    const scheduleLessonId = schedule && schedule.lesson && schedule.lesson.id
      ? schedule.lesson.id
      : null;

    const body = {
      user_id: isFamilyMember ? this.users : [this.user.id],
      program_id: isFamilyMember ? this.selectedClassSchedule.program_id : schedule.program_id,
      schedule_id: isFamilyMember ? this.selectedClassSchedule.id : schedule.id,
      class_id: isFamilyMember ? this.selectedClassSchedule.class_id : schedule.class_id,
      lesson_id: isFamilyMember ? selectedScheduleLessonId : scheduleLessonId,
      created_at: moment().format('YYYY-MM-DD HH:mm:ss')
    };
    this.attendanceService.checkIn(body).subscribe(
      (resp: { data: any, status: number }) => {
        if (resp.status === 200) {
          if (resp.data[0] && Array.isArray(resp.data[0])) {
            this.authStore.dispatch(new UpdateAuthUser({
              yearAttendanceFromApi: resp.data[0]
            }));
            this.close({status: 'checked_in', attendanceChanged: true});
            return;
          }

          for (let i = 0; i < resp.data.length; i++) {
            if (resp.data[i].status === 13200) {
              this.close({status: 'onboarding_required', attendanceChanged: false});
              this.onboardingRegisterDialog = this.dialog.open(OnboardingRegisterComponent);
              OnboardingRegisterComponent.modalRef = this.onboardingRegisterDialog;
              return;
            }
          }

          if (resp.data && resp.data.length > 0 && resp.data[0]) {
            const response = resp.data[0];

            // need to pay status
            if (
              response.status === 11200 &&
              response.user &&
              response.user.systemSubscriptionStatus &&
              response.user.systemSubscriptionStatus.length > 0
            ) {
              this.close({status: 'payment_required', attendanceChanged: false});
              const status = response.user.systemSubscriptionStatus[0];
              if (status && status.status !== 'active') {
                this.openRechargeFailedChargeStudentDialog(status);
              }
              return;
            }

            if (response.is_already_checked) {
              this.close({status: 'already_checked_in', attendanceChanged: true});
            }
          }
        }
      }, error => {
        console.log('check in error', error);
      });
  }

  openRechargeFailedChargeStudentDialog(systemSubscriptionStatus) {
    RechargeFailedChargeStudentDialog.systemSubscriptionStatus = systemSubscriptionStatus;
    this.rechargeFailedChargeStudentDialog = this.dialog.open(RechargeFailedChargeStudentDialog);
    RechargeFailedChargeStudentDialog.modalRef = this.rechargeFailedChargeStudentDialog;
    this.rechargeFailedChargeStudentDialog.afterClosed().subscribe(result => {
      this.rechargeFailedChargeStudentDialog.close();
    });
  }

  getPayments() {
    this.paymentsService.getPaymentsInformation().subscribe(
      (resp: { data: any }) => {
        this.overduePayments = resp.data.overduePayments;
        this.nextPayments = resp.data.nextPayments;
        this.previousPayments = resp.data.previousPayments;
        if (this.overduePayments && this.overduePayments.length) {
          this.overduePayments.map((item) => {
            this.payForSubscription(item.program_id, item.subscription_id);
          });
        }
      }
    );
  }

  payForSubscription(program_id, subscription_id) {
    this.paymentsService.createChargeForProgram(program_id, subscription_id).subscribe(
      (resp: { data: any }) => {
        if (resp.data.status === 'redirect' && resp.data.url && resp.data.url.length > 0) {
          document.location.replace(resp.data.url);
        } else {
          this.overduePayments.map((item, i) => {
            if (item.program_id === program_id && item.subscription_id === subscription_id) {
              this.overduePayments.splice(i, 1);
            }
          });
          this.previousPayments.push(resp.data);
        }
      }
    );
  }

  goToMembershipPage() {
    this.router.navigate(['/subscriptions']);
  }

  close(result?: { status: string, attendanceChanged: boolean }) {
    CheckInOptionsComponent.modalRef.close(result);
  }

  onChange(event, schedule) {
    if (event.checked) {
      this.classesSchedulesForCheckIn.push(schedule);
    } else {
      const index = this.classesSchedulesForCheckIn.indexOf(schedule);
      this.classesSchedulesForCheckIn.splice(index, 1);
    }
  }

  onChangeFamily(event, id) {
    if (event.checked) {
      this.users.push(id);
    } else {
      const index = this.users.indexOf(id);
      this.users.splice(index, 1);
    }
  }

  isCheckedIn(schedule) {
    let checked = false;
    this.attendancesByDay.map(a => {
      if (a.class_id === schedule.class_id && a.schedule_id === schedule.id) {
        checked = true;
      }
    });
    return checked;
  }

  getStudents(event) {
    if (event.target.value && event.target.value.length > 0) {
      this.students = this.searchStudents.filter( s => s.name.indexOf(event.target.value) > -1);
    } else {
      this.students = this.searchStudents;
    }
  }
}
